<template>
    <div>
        <div class="card-body" v-if="!loading && length==0">
            <div class="row">
                <div class="col-12 text-center">{{$t('Nothing yet')}}</div>
            </div>
        </div>
        <div class="card-body" v-if="loading">
            <div class="row align-items-center active">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">{{$t('Loading...')}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['loading', 'length']
}
</script>

<style>

</style>
